<script lang="ts">
    import { twMerge } from 'tailwind-merge';
    import { iconClasses } from './icon-settings';

    let className = '';
    export { className as class };
</script>

<svg
    class={twMerge(iconClasses, className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
        d="M9 18C7.344 18 6 19.344 6 21C6 22.656 7.344 24 9 24C10.656 24 12 22.656 12 21C12 19.344 10.656 18 9 18ZM18 18C16.344 18 15 19.344 15 21C15 22.656 16.344 24 18 24C19.656 24 21 22.656 21 21C21 19.344 19.656 18 18 18ZM22.5 3H6.105L5.7 1.5C5.391 0.153 4.5465 0 4.149 0H1.5C0.672 0 0 0.672 0 1.5C0 2.328 0.672 3 1.5 3H3L6 13.8045C6.282 14.6955 6.9495 15 7.5 15H19.5C20.121 15 20.6715 14.6835 21 13.8285L23.5725 6C23.8005 5.274 24 4.875 24 4.5C24 3.504 23.145 3 22.5 3ZM18.4425 12H8.613L6.9465 6H20.415L18.4425 12Z"
        fill="white" />
</svg>
